<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="notice__page">
          <ul class="notice__page__ul">
            <li class="notice__page__li type_02" v-for="(item, index) in noticeList" :key="index" @click="fnView(item)">
              <div class="txt">
                <p>{{ item.boardTitle }}</p>
                <p class="date">{{ $moment(item.regDate).format('YYYY.MM.DD') }}</p>
              </div>
              <i class="i_right"></i>
            </li>
          </ul>
          <infinite-loading @infinite="getNoticeList">
            <div slot="spinner"></div>
            <div slot="no-more"></div>
            <div slot="no-results">
              <div class="complete">
                <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img">
                <span class="complete__txt__type02">내역이 없습니다.</span>
              </div>
            </div>
          </infinite-loading>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: {InfiniteLoading},
  data: function () {
    return {
      params: {
        page: 1,
        limit: 20,
        boardType: 1
      },
      pageInfo: {},
      noticeList: []
    }
  },
  created: function () {
  },
  methods: {
    getNoticeList: async function ($state) {
      console.log(this.params)
      const res = await this.$MypageSvc.getBoardList(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.noticeList = this.noticeList.concat(entity.list)
        this.pageInfo = entity.pageInfo
        this.params.page = this.params.page + 1

        if (this.pageInfo.page >= this.pageInfo.endPage) {
          $state.complete()
        }
        if (this.pageInfo.totalRow > 0) {
          $state.loaded()
        }
      } else {
        $state.complete()
        this.$Util.modalAlert({message: message})
      }
    },
    fnView: function (item) {
      this.$router.push({
        path: '/mypage/noticeDetail',
        query: {boardNo: item.boardNo}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.complete__img {
  margin-top: -192% !important;
}
</style>
